module.exports = __webpack_public_path__ + "static/media/3.443997a6.webp";